import React, { createContext, useContext, useEffect, useMemo } from 'react'

import useFileUploaderManager from 'hooks/useFileUploaderManager'
import { showAlertSuccess } from 'client/methods'
import { getBaseURI } from 'client/links/httpLink'

const UploadContext = createContext()

export function WorkerUploaderProvider({ children }) {
  const { uploads, createUploader, getUploader } = useFileUploaderManager({
    uploadUrl: `${getBaseURI(localStorage.getItem('DB_USER_REGION'))}/graphql`
  })

  useEffect(() => {
    createUploader({
      operationName: 'UpdateNoteMutation',
      mutation: `
        mutation UpdateNoteMutation($id: ID!, $input: UpdateSmartNoteInput!) {
          updateSmartNote(id: $id, input: $input) {
            id
          }
        }
      `
    })
  }, [createUploader])

  useEffect(() => {
    if (uploads.length > 0) {
      const lastUpload = uploads[uploads.length - 1]
      if (lastUpload.status === 'Completed') {
        showAlertSuccess('File uploaded successfully!')
      }
    }
  }, [uploads])

  const contextValue = useMemo(
    () => ({ uploads, getUploader }),
    [uploads, getUploader]
  )

  return (
    <UploadContext.Provider value={contextValue}>
      {children}
    </UploadContext.Provider>
  )
}

export const useWorkerUploadContext = () => useContext(UploadContext)

export default UploadContext
